/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { MdOutlineWifi, MdOutlineWifiOff } from 'react-icons/md'
import { RiZzzLine } from 'react-icons/ri'

import AssetTableCell from './AssetTableCell'
import { createTooltip } from './utils'

type GatewayIconProps = {
  gatewayOn: boolean
  addressShort?: string
  geofence?: string
  umdSleepMode?: boolean
  umdBatteryVoltage?: number
  umdSampleTime?: Date
}

const renderGatewayIcon = (gatewayOn: boolean, isSleep: boolean) => {
  if (gatewayOn) {
    return <MdOutlineWifi className="w-4 h-4 text-green-500" />
  }
  if (isSleep) {
    return <RiZzzLine className="w-4 h-4 text-gray-500" />
  }
  return <MdOutlineWifiOff className="w-4 h-4 text-gray-500" />
}

const GatewayIcon: React.FC<GatewayIconProps> = ({
  gatewayOn,
  addressShort,
  geofence,
  umdBatteryVoltage,
  umdSampleTime,
  umdSleepMode,
}) => {
  const geofenceTooltip = geofence ? '\nLast known geofence: ' + geofence : '\nLast known geofence: None'
  const addressTooltip = 'Last known address: ' + addressShort + geofenceTooltip

  let tooltip = ''
  if (gatewayOn) {
    tooltip = createTooltip('Online')
  } else if (umdSleepMode) {
    tooltip = createTooltip(
      'Device in sleep mode',
      umdSampleTime,
      'UMD battery voltage: ' + (umdBatteryVoltage || 'Unknown') + '\n' + addressTooltip
    )
  } else {
    tooltip = createTooltip('Offline', umdSampleTime, addressTooltip)
  }

  return (
    <AssetTableCell tooltip={tooltip}>
      <div className="w-full h-full flex items-center justify-center">
        {renderGatewayIcon(gatewayOn, !!umdSleepMode)}
      </div>
    </AssetTableCell>
  )
}

export default GatewayIcon
